// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3p5kO","alertIcon":"ConfirmModal_alertIcon__3Llqz"};